import React from "react";
import { BiChevronLeft } from "react-icons/bi";
import { BsArrowRight } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import { GoChecklist } from "react-icons/go";
import Loading from "../../Components/Loading";
import { useCities } from "./Hooks";

const Cities = () => {
  const {
    citys,
    form,
    setForm,
    province,
    loading,
    getValue,
    changeObj,
    dispatch,
    city,
    navigate,
  } = useCities();
  if (loading.province || loading.city) {
    return <Loading height={"30px"} count={5} />;
  }
  return (
    <>
      <div className="tiTle">
        {getValue("province_id") ? (
          <button
            className="btn"
            onClick={() => {
              changeObj("province_id", "");
            }}
          >
            <BsArrowRight />
          </button>
        ) : (
          <GoChecklist />
        )}

        <p className="txt">
          {getValue("province_id") ? <>همه شهر ها</> : <>انتخاب شهر</>}
        </p>
      </div>

      <div className="container">
        <div className="row">
          {getValue("province_id") ? (
            <>
              {citys.map(city => {
                return (
                  <div
                    className="col-12"
                    onClick={() => {
                      dispatch("city", {
                        ...city,
                        province_id: getValue("province_id"),
                      });
                      navigate("/list");
                    }}
                  >
                    <div className="city d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <div>
                          <CiLocationOn />
                        </div>
                        <div>
                          <p style={{ fontSize: "12px", fontWeight: "400" }}>
                            {city.label}
                          </p>
                        </div>
                      </div>

                      <div>
                        <BiChevronLeft size="1.2rem" />
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <>
              {province.map(pro => {
                return (
                  <div
                    className="col-12"
                    onClick={() => changeObj("province_id", pro.value)}
                  >
                    <div className="city d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <div>
                          <CiLocationOn />
                        </div>
                        <div>
                          <p style={{ fontSize: "12px", fontWeight: "400" }}>
                            {pro.label}
                          </p>
                        </div>
                      </div>

                      <div>
                        <BiChevronLeft size="1.2rem" />
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Cities;
